/* Geurvinder engine — pure matching logic, no DOM. Shared by the theme section and the preview. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.GeurvinderEngine = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // Scent groups shown in question 2. `fam` = canonical family names (from metafield custom.geurfamilie,
  // shopify.olfactory-family or family tags). `kw` = note / title keywords used when families are missing.
  var GROUPS = {
    zoet:    { label: 'Zoet & gourmand',   hint: 'vanille, karamel, chocolade', color: '#c48a3f',
               fam: ['gourmand', 'zoet'],
               kw: ['vanille', 'vanilla', 'karamel', 'caramel', 'chocolade', 'choco', 'praline', 'honing', 'suiker', 'rietsuiker', 'tonkaboon', 'tonka', 'marshmallow', 'pistache', 'koffie', 'coffee', 'dadel', 'toffee', 'sugar', 'candy', 'cake', 'benzoin', 'amandel'] },
    fris:    { label: 'Fris & schoon',     hint: 'citrus, zee, zeep', color: '#3f9db3',
               fam: ['fris', 'aquatisch', 'aromatisch', 'fougere', 'citrus', 'groen'],
               kw: ['citroen', 'bergamot', 'grapefruit', 'mandarijn', 'sinaasappel', 'pepermunt', 'munt', 'aquatische', 'lavendel', 'neroli', 'gember', 'aqua', 'fresh', 'ocean', 'zee', 'limoen', 'citrus'] },
    bloemig: { label: 'Bloemig & poederig', hint: 'roos, jasmijn, witte musk', color: '#cf7d9c',
               fam: ['bloemig', 'poederig'],
               kw: ['roos', 'jasmijn', 'iris', 'orris', 'violet', 'tuberoos', 'oranjebloesem', 'witte musk', 'orchidee', 'freesia', 'pioen', 'lelie', 'ylang', 'gardenia', 'witte bloemen', 'bloemige', 'rose', 'kamperfoelie', 'tiare'] },
    houtig:  { label: 'Houtig & oud',      hint: 'oud, sandelhout, leer', color: '#7b5534',
               fam: ['houtachtig', 'leerachtig', 'rokerig', 'chypre', 'oud'],
               kw: ['oud', 'oudh', 'sandelhout', 'cederhout', 'vetiver', 'patchoeli', 'leer', 'leather', 'wood', 'santal', 'guaiac', 'eikenmos', 'amberhout', 'tabak', 'houtachtige'] },
    kruidig: { label: 'Warm & kruidig',    hint: 'saffraan, amber, kaneel', color: '#b4532e',
               fam: ['kruidig', 'amber', 'oosters', 'balsamisch'],
               kw: ['saffraan', 'kaneel', 'kardemom', 'nootmuskaat', 'peper', 'amber', 'kruidnagel', 'wierook', 'olibanum', 'frankincense', 'mirre', 'labdanum', 'ambergris', 'kruidige', 'spice', 'elemi'] },
    fruitig: { label: 'Fruitig',           hint: 'peer, framboos, appel', color: '#c9475a',
               fam: ['fruitig'],
               kw: ['peer', 'framboos', 'appel', 'perzik', 'aardbei', 'zwarte bes', 'kers', 'ananas', 'pruim', 'mango', 'lychee', 'fruitige', 'berry', 'meloen', 'kokos'] }
  };
  var GROUP_ORDER = ['zoet', 'fris', 'bloemig', 'houtig', 'kruidig', 'fruitig'];
  var LIGHT = ['fris', 'bloemig', 'fruitig'];
  var HEAVY = ['houtig', 'kruidig', 'zoet'];

  var CANON = {};
  GROUP_ORDER.forEach(function (g) { GROUPS[g].fam.forEach(function (f) { CANON[f] = g; }); });
  var ALIASES = {
    houtig: 'houtachtig', houtige: 'houtachtig', leder: 'leerachtig', leer: 'leerachtig',
    poederachtig: 'poederig', balsamiek: 'balsamisch', orientaals: 'oosters', oriental: 'oosters',
    aquatische: 'aquatisch', kruidige: 'kruidig', aromatische: 'aromatisch', bloemige: 'bloemig',
    fruitige: 'fruitig', frisse: 'fris', zoete: 'zoet', rozenparfum: 'bloemig', gourmande: 'gourmand'
  };
  var STOP = { eau: 1, de: 1, du: 1, la: 1, le: 1, parfum: 1, perfume: 1, the: 1, for: 1, pour: 1, by: 1, edp: 1, edt: 1, men: 1, women: 1, homme: 1, femme: 1, intense: 0 };

  var ACCENTS = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g');
  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(ACCENTS, '');
  }
  function flat(s) { return norm(s).replace(/[^a-z0-9]+/g, ' ').trim(); }
  function words(s) { return ' ' + flat(s) + ' '; }
  function list(s) {
    return String(s == null ? '' : s).split('|').map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function canonFamily(s) {
    var n = flat(s).replace(/ (parfums?|geuren|geur)$/, '');
    return ALIASES[n] || n;
  }

  function formOf(type) {
    var t = flat(type);
    if (/sample|pocket|set|mist|bundel|cadeau|deodorant|lotion|auto|room|lucht|haar|body|tester/.test(t)) return null;
    if (/parfumolie|attar|pure geurolie|perfume oil/.test(t)) return 'olie';
    if (/eau de parfum|eau de toilette|parfumspray|aquaparfum|extrait|cologne|^parfum$/.test(t)) return 'spray';
    return null;
  }

  function genderOf(raw, tagsW, titleW) {
    var M = false, F = false, U = false;
    list(raw.g).concat(list(raw.x)).forEach(function (v) {
      var n = flat(v);
      if (/^(heren|man|mannen|mannelijk|male|men)\b/.test(n)) M = true;
      else if (/^(dames|vrouw|vrouwen|vrouwelijk|female|women)\b/.test(n)) F = true;
      else if (/unisex|uniseks/.test(n)) U = true;
    });
    if (U || (M && F)) return 'U';
    if (M) return 'M';
    if (F) return 'F';
    if (/ unisex| uniseks/.test(tagsW)) U = true;
    if (/ heren| herenparfum| herengeur/.test(tagsW)) M = true;
    if (/ dames| damesparfum| damesgeur/.test(tagsW)) F = true;
    if (U || (M && F)) return 'U';
    if (M) return 'M';
    if (F) return 'F';
    var tm = /( for men | pour homme | homme | man | men | him | heren )/.test(titleW);
    var tf = /( for women | pour femme | femme | woman | women | her | girl | lady | dames )/.test(titleW);
    if (tm && !tf) return 'M';
    if (tf && !tm) return 'F';
    return '?';
  }

  function groupMatch(P, g) {
    var G = GROUPS[g];
    for (var i = 0; i < G.fam.length; i++) if (P.fam[G.fam[i]]) return 1;
    var best = 0;
    for (var j = 0; j < G.kw.length; j++) {
      var k = ' ' + G.kw[j] + ' ';
      if (P.titleW.indexOf(k) >= 0) best = Math.max(best, 0.7);
      else if (P.notesW.indexOf(k) >= 0) best = Math.max(best, 0.5);
      else if (P.tagsW.indexOf(k) >= 0) best = Math.max(best, 0.45);
    }
    return best;
  }

  function baseKey(vendor, title) {
    var t = flat(title)
      .replace(/\b(eau de parfum|eau de toilette|parfumolie|parfumspray|parfum|edp|edt)\b/g, ' ')
      .replace(/\b\d+\s?ml\b/g, ' ')
      .replace(/\s+/g, ' ').trim();
    return flat(vendor) + '::' + t;
  }

  // Strip " - EDP", size suffixes and the vendor name at the start of the title. Also handles the type words
  // of translated titles (" – Parfümöl", " – Perfume oil", ...).
  var TYPE_SUFFIX = /\s+[-–—]\s+(edp|edt|eau de parfum|eau de toilette|extrait|parfumolie|parfumspray|parfümöl|parfümspray|perfume oil|perfume spray|huile parfumée|huile de parfum|aceite de perfume|aceite perfumado)(?![\wÀ-ɏ]).*$/i;
  function displayTitle(title, vendor) {
    var t = String(title || '').replace(TYPE_SUFFIX, '').trim();
    var vk = flat(vendor).replace(/ /g, '');
    var parts = t.split(/\s+/);
    var acc = '', cut = 0;
    for (var i = 0; i < parts.length - 1; i++) {
      acc += flat(parts[i]).replace(/ /g, '');
      if (!acc || vk.indexOf(acc) !== 0) break;
      cut = i + 1;
      if (acc === vk) break;
    }
    return cut > 0 ? parts.slice(cut).join(' ') : t;
  }

  function prepare(raw, i, n) {
    var title = String(raw.t || '');
    var tags = list(raw.tg).map(function (t) { return t.replace(/^ai_collectie_/i, '').replace(/[-_]+/g, ' '); });
    var famRaw = list(raw.f).concat(list(raw.o));
    var fam = {};
    famRaw.forEach(function (f) { fam[canonFamily(f)] = 1; });
    if (!famRaw.length) {
      tags.forEach(function (t) { var c = canonFamily(t); if (CANON[c]) fam[c] = 1; });
    }
    var P = {
      raw: raw,
      title: title,
      name: displayTitle(title, raw.v),
      vendor: String(raw.v || ''),
      form: formOf(raw.y),
      price: Number(raw.p) || 0,
      fam: fam,
      hasFamilies: Object.keys(fam).length > 0,
      titleW: words(title),
      notesW: words(list(raw.n).join(' ')),
      tagsW: words(tags.join(' ')),
      occW: words(list(raw.oc).join(' ')),
      like: String(raw.l || ''),
      likeN: flat(raw.l),
      titleN: flat(title),
      key: baseKey(raw.v, title),
      lo: Number(raw.lo) || 0,
      best: Number(raw.b) || 0,
      pop: n > 1 ? 1 - (Number(raw.r != null ? raw.r : i) || 0) / n : 1,
      gm: {}
    };
    P.gender = genderOf(raw, P.tagsW, P.titleW);
    GROUP_ORDER.forEach(function (g) { P.gm[g] = groupMatch(P, g); });
    var top = null, topV = 0;
    GROUP_ORDER.forEach(function (g) { if (P.gm[g] > topV) { topV = P.gm[g]; top = g; } });
    P.primary = top;
    P.color = top ? GROUPS[top].color : '#9a8f86';
    return P;
  }

  function prepareAll(raws) {
    var n = raws.length;
    var out = [];
    for (var i = 0; i < n; i++) {
      var P = prepare(raws[i], i, n);
      if (P.form && P.price > 0) out.push(P);
    }
    return out;
  }

  // ---------- scoring ----------
  var W = { gender: 30, fam: 40, moment: 12, budget: 12 };
  var MAX = W.gender + W.fam + W.moment + W.budget;

  function genderScore(P, want) {
    var g = P.gender;
    if (want === 'him') return g === 'M' ? 1 : g === 'U' ? 0.85 : g === '?' ? 0.55 : -1;
    if (want === 'her') return g === 'F' ? 1 : g === 'U' ? 0.85 : g === '?' ? 0.55 : -1;
    return g === 'U' ? 1 : g === '?' ? 0.6 : 0.85;
  }
  function famScore(P, fams) {
    if (!fams || !fams.length) return 0.7;
    var m = fams.map(function (g) { return P.gm[g] || 0; });
    if (m.length === 1) return m[0];
    var max = Math.max.apply(null, m), sum = m.reduce(function (a, b) { return a + b; }, 0);
    return 0.5 * max + 0.5 * (sum / m.length);
  }
  function momentScore(P, moment) {
    // shopify.occasion metafield wins when it is filled in
    if (moment === 'dag' && /( dagelijks | casual | kantoor | werk | sport | everyday | office | daytime )/.test(P.occW)) return 1;
    if (moment === 'avond' && /( avond | formeel | feest | evening | formal | party | date | night )/.test(P.occW)) return 1;
    var light = Math.max.apply(null, LIGHT.map(function (g) { return P.gm[g]; }));
    var heavy = Math.max.apply(null, HEAVY.map(function (g) { return P.gm[g]; }));
    if (!light && !heavy) return 0.6;
    if (moment === 'dag') return light > heavy ? 1 : light === heavy ? 0.75 : 0.35 + 0.3 * light;
    if (moment === 'avond') {
      var s = heavy > light ? 1 : light === heavy ? 0.75 : 0.35 + 0.3 * heavy;
      if (P.lo >= 7) s = Math.min(1, s + 0.15);
      return s;
    }
    return light && heavy ? 1 : 0.85;
  }
  // returns [score, tierPenalty] ; tier 1 = outside budget tolerance
  function budgetScore(P, budget, L, H) {
    var p = P.price / 100;
    if (budget === 'low') return p <= L ? [1, 0] : p <= L * 1.25 ? [0.45, 0, 'near'] : [0.2, 1, 'over'];
    if (budget === 'mid') return (p > L && p <= H) ? [1, 0] : p <= L ? [0.7, 0] : p <= H * 1.2 ? [0.45, 0, 'near'] : [0.2, 1, 'over'];
    if (budget === 'high') return p > H ? [1, 0] : p > H * 0.8 ? [0.6, 0] : [0.15, 0];
    return [1, 0];
  }

  // M = matcher from geurvinder-match.js (lijkt op / reference perfume), or null.
  // M.score(P) -> { s: overall similarity 0..1, d: direct lijkt_op match 0..1 } or null
  function scoreOne(P, A, L, H, M) {
    var gs = genderScore(P, A.gender);
    if (gs < 0) return null;
    var tier = 0, flags = {};
    if (A.form && A.form !== 'any' && P.form !== A.form) { tier = 2; flags.form = true; }
    var m = M ? M.score(P) : null;

    if (A.mode === 'like') {
      if (!m) return null;
      // no gender answer yet: lean towards the gender of the perfume searched for
      if (!A.gender && M.want) { gs = genderScore(P, M.want); if (gs < 0) gs = 0.2; }
      var lt = 70 * m.s + 20 * gs + (M.R ? 6 : 10) * P.pop;
      return { P: P, tier: tier, pct: Math.round(Math.min(99, 60 + 39 * m.s)), rankScore: lt + (P.best ? 3 : 0), like: m.d, sim: m.s, flags: flags, parts: { gs: gs } };
    }

    var fs = famScore(P, A.fams);
    var ms = momentScore(P, A.moment);
    var b = budgetScore(P, A.budget, L, H);
    if (b[1]) tier = Math.max(tier, 1);
    if (b[2]) flags[b[2]] = true;
    var total = W.gender * gs + W.fam * fs + W.moment * ms + W.budget * b[0];
    var pct = Math.round(Math.min(99, 100 * total / MAX));
    var rankScore = total + 6 * P.pop + (P.best ? 3 : 0) + (P.raw.s ? 0.5 : 0);
    if (m) rankScore += 25 * m.d + 12 * m.s;
    return { P: P, tier: tier, pct: pct, rankScore: rankScore, like: m ? m.d : 0, sim: m ? m.s : 0, flags: flags, parts: { gs: gs, fs: fs, ms: ms, bs: b[0] } };
  }

  // Reason codes, turned into text by the view: like, f:<group>, gM, gF, gU, day, eve
  function reasons(r, A) {
    var P = r.P, out = [];
    if (r.like >= 0.8 && P.like) out.push('like');
    if (A.mode !== 'like') {
      (A.fams || []).forEach(function (g) { if ((P.gm[g] || 0) >= 0.5 && out.length < 2) out.push('f:' + g); });
    } else if (P.primary && P.gm[P.primary] >= 0.5) {
      out.push('f:' + P.primary);
    }
    if (P.gender === 'M' || P.gender === 'F' || P.gender === 'U') out.push('g' + P.gender);
    if (A.mode !== 'like' && r.parts.ms >= 1 && A.moment === 'dag') out.push('day');
    if (A.mode !== 'like' && r.parts.ms >= 1 && A.moment === 'avond') out.push('eve');
    return out.slice(0, 3);
  }

  function rank(pool, A, opts) {
    opts = opts || {};
    var L = Number(opts.budgetLow) || 15, H = Number(opts.budgetHigh) || 30;
    var perPage = opts.perPage || 3, max = opts.max || perPage * 3;
    var M = opts.matcher || null;
    var scored = [];
    for (var i = 0; i < pool.length; i++) {
      var r = scoreOne(pool[i], A, L, H, M);
      if (r) scored.push(r);
    }
    scored.sort(function (a, b) { return a.tier - b.tier || b.rankScore - a.rankScore; });

    // dedupe same scent (spray/oil/size variants) and cap 2 per vendor per page
    var seen = {}, out = [], deferred = [], vendorPage = {};
    for (var j = 0; j < scored.length && out.length < max; j++) {
      var s = scored[j];
      if (seen[s.P.key]) continue;
      var page = Math.floor(out.length / perPage);
      var vk = page + '|' + s.P.vendor;
      if ((vendorPage[vk] || 0) >= 2) { deferred.push(s); continue; }
      seen[s.P.key] = 1;
      vendorPage[vk] = (vendorPage[vk] || 0) + 1;
      s.reasons = reasons(s, A);
      out.push(s);
    }
    for (var k = 0; k < deferred.length && out.length < max; k++) {
      if (seen[deferred[k].P.key]) continue;
      seen[deferred[k].P.key] = 1;
      deferred[k].reasons = reasons(deferred[k], A);
      out.push(deferred[k]);
    }
    // popularity breaks ties, so keep the shown percentages from climbing down the list within a tier
    for (var x = 1; x < out.length; x++) {
      if (out[x].tier === out[x - 1].tier && out[x].pct > out[x - 1].pct) out[x].pct = out[x - 1].pct;
    }
    return out;
  }

  return {
    GROUPS: GROUPS,
    GROUP_ORDER: GROUP_ORDER,
    prepareAll: prepareAll,
    rank: rank,
    displayTitle: displayTitle,
    _internal: {
      genderOf: genderOf, formOf: formOf, flat: flat, words: words, list: list, prepare: prepare, STOP: STOP,
      genderScore: genderScore, famScore: famScore, budgetScore: budgetScore
    }
  };
});